<template src="./gestioneAuditor.html"></template>

<script>
import { get_listaClienti } from "@/api/api.dati.js";
import {
    get_listaAuditor,
    get_assegnazioniAuditor,
    assegna_azienda_auditor,
    rimuovi_assegnazione_auditor,
    crea_auditor,
} from "@/api/api.auditor.js";
import CampoData from "@/components/cliente/CampoData.vue";

export default {
    components: { CampoData },

    data: () => ({
        loading: false,

        auditor: [],
        assegnazioni: [],
        aziende: [],

        headersAuditor: [
            { text: "Nome utente", value: "username", sortable: false },
            { text: "E-mail", value: "eMail", sortable: false },
        ],

        headersAssegnazioni: [
            { text: "Codice", value: "companyCode", sortable: false },
            { text: "Ragione Sociale", value: "ragioneSociale", sortable: false },
            { text: "Certificazione", value: "tipoCertificazione", sortable: false },
            { text: "Auditor", value: "auditorUserName", sortable: false },
            { text: "Scadenza", value: "expiryDate", sortable: false },
            { text: "Azioni", value: "azioni", sortable: false },
        ],

        dialogNuovoAuditor: false,
        nuovoAuditor: {
            userName: "",
            eMail: "",
            passwordHash: "",
        },

        aziendaSelezionata: null,
        auditorSelezionato: null,
        certFsc: false,
        certPefc: false,
        scadenza: null,

        dialogModifica: false,
        assegnazioneInModifica: {},
        auditorModifica: null,
        scadenzaModifica: null,
    }),

    methods: {
        async caricaDati() {
            this.loading = true;
            try {
                const [resAuditor, resAssegnazioni, resAziende] = await Promise.all([
                    get_listaAuditor(),
                    get_assegnazioniAuditor(),
                    get_listaClienti({ Cliente: true, Gruppo: "Tutti" }),
                ]);
                this.auditor = resAuditor.data;
                this.assegnazioni = resAssegnazioni.data.map((a) => ({ ...a, rowKey: a.companyCode + "-" + a.tipoCertificazione }));
                this.aziende = resAziende.data;
            } catch (error) {
                this.$toast.alert("Errore durante il caricamento dei dati");
                console.error(error);
            } finally {
                this.loading = false;
            }
        },

        apriNuovoAuditor() {
            this.nuovoAuditor = { userName: "", eMail: "", passwordHash: "" };
            this.dialogNuovoAuditor = true;
        },

        async salvaNuovoAuditor() {
            if (!this.nuovoAuditor.userName || !this.nuovoAuditor.passwordHash) {
                this.$toast.alert("Nome utente e password sono obbligatori");
                return;
            }

            const res = await crea_auditor(this.nuovoAuditor);
            if (res.data === "OK") {
                this.$toast.info("Auditor creato con successo!");
                this.dialogNuovoAuditor = false;
                await this.caricaDati();
            } else {
                this.$toast.alert(res.data);
            }
        },

        async assegna() {
            if (!this.aziendaSelezionata || !this.auditorSelezionato) {
                this.$toast.alert("Seleziona azienda e auditor");
                return;
            }
            if (!this.certFsc && !this.certPefc) {
                this.$toast.alert("Seleziona almeno una certificazione (FSC o PEFC)");
                return;
            }

            const par = {
                CompanyCode: this.aziendaSelezionata.companyCode,
                AuditorUserId: this.auditorSelezionato.userId,
                Fsc: this.certFsc,
                Pefc: this.certPefc,
                ExpiryDate: this.scadenza,
            };

            const res = await assegna_azienda_auditor(par);
            if (res.data === "OK") {
                this.$toast.info("Azienda assegnata con successo!");
                this.aziendaSelezionata = null;
                this.auditorSelezionato = null;
                this.certFsc = false;
                this.certPefc = false;
                this.scadenza = null;
                await this.caricaDati();
            } else {
                this.$toast.alert(res.data);
            }
        },

        apriModifica(item) {
            this.assegnazioneInModifica = item;
            this.auditorModifica = this.auditor.find((a) => a.userId === item.auditorUserId) || null;
            this.scadenzaModifica = item.expiryDate ? item.expiryDate.substring(0, 10) : null;
            this.dialogModifica = true;
        },

        async salvaModifica() {
            if (!this.auditorModifica) {
                this.$toast.alert("Seleziona un auditor");
                return;
            }

            const par = {
                CompanyCode: this.assegnazioneInModifica.companyCode,
                AuditorUserId: this.auditorModifica.userId,
                Fsc: this.assegnazioneInModifica.tipoCertificazione === "FSC",
                Pefc: this.assegnazioneInModifica.tipoCertificazione === "PEFC",
                ExpiryDate: this.scadenzaModifica,
            };

            const res = await assegna_azienda_auditor(par);
            if (res.data === "OK") {
                this.$toast.info("Assegnazione aggiornata con successo!");
                this.dialogModifica = false;
                await this.caricaDati();
            } else {
                this.$toast.alert(res.data);
            }
        },

        async rimuovi(item) {
            let confirm = await this.$confirm.open(
                "Rimuovi assegnazione",
                "Vuoi rimuovere l'assegnazione " + item.tipoCertificazione + " di <b>" + item.ragioneSociale + "</b> all'auditor <b>" + item.auditorUserName + "</b>?"
            );
            if (!confirm) return;

            const par = {
                CompanyCode: item.companyCode,
                TipoCertificazione: item.tipoCertificazione,
            };

            const res = await rimuovi_assegnazione_auditor(par);
            if (res.data === "OK") {
                this.$toast.info("Assegnazione rimossa con successo!");
                await this.caricaDati();
            } else {
                this.$toast.alert(res.data);
            }
        },

        formattaScadenza(item) {
            if (!item.expiryDate) return "Nessuna scadenza";
            return this.$i2kFunctions.formatISODate(item.expiryDate.substring(0, 10));
        },
    },

    created() {
        if (this.role != "admin") this.$router.push({ path: "/" });
    },

    mounted() {
        this.caricaDati();
    },

    computed: {
        role() {
            return this.$store.getters["user/getRole"];
        },

        // elenco aziende con indicazione delle certificazioni gia' assegnate (e a chi)
        // selezionare una certificazione gia' assegnata ne sostituisce l'assegnazione esistente
        aziendeConLabel() {
            return this.aziende.map((a) => {
                const assegnazioniAzienda = this.assegnazioni.filter((x) => x.companyCode === a.companyCode);
                const label = assegnazioniAzienda.length
                    ? `${a.ragioneSociale} (${assegnazioniAzienda.map((x) => `${x.tipoCertificazione}: ${x.auditorUserName}`).join(", ")})`
                    : a.ragioneSociale;
                return { ...a, label };
            });
        },
    },
};
</script>
